import { Component, OnInit, OnDestroy, HostBinding} from '@angular/core';
import { OxeModelService } from '../oxe-model-service/oxe-model.service';
import { INode } from '../Configuration/INode';
import { HelpService } from '../help-service/help.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'wbm-config-help',
    templateUrl: 'config-help.component.html',
    styleUrls: ['../../assets/theme/css/ConfigHelp.css']
})
export class ConfigHelpComponent implements OnInit, OnDestroy {
    @HostBinding() class = 'home-box home-box--gutter-left flex-item-fluid flex-container-v nowrap mw35 vertical-rhythm mam ml0';

    private subscriptions: Array<Subscription> = [];

    public node: INode;

    public get helpDisplayed(): boolean {
        return this._helpService.isHelpDisplayed();
    }

    constructor(
        private _oxeModel: OxeModelService,
        private _helpService: HelpService
    ) { }

    ngOnInit() {
        this.subscriptions.push(this._oxeModel.helpNodeObserver
            .subscribe(this.updateConfigHelp.bind(this)));
    }

    ngOnDestroy() {
        //release global subscriptions
        this.removeGlobalSubscriptions();
    }

    private removeGlobalSubscriptions() {
        while (this.subscriptions.length > 0) {
            this.subscriptions.pop().unsubscribe();
        }
    }

    public updateConfigHelp(node: INode) {
        if (node) {
            this.node = node;
        }
    }

    public get className(): string {
        if (this.node) {
            return this.node.isClassNode ? this.node.name : this.node.parent.name;
        }
        return undefined;
    }

    public get classHelp(): string {
        if (this.node) {
            return this._helpService.getHelpContent(this.className);
        }
        return undefined;
    }

    public onCloseHelp(): void {
        this._helpService.enableHelpDisplay(false);
    }
}
